import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import Head from 'next/head';

import Api from 'src/data/api';
import withAuth from 'src/components/withAuth';
import Settings from 'src/components/settings';
import Loader from 'src/components/loader/fullscreen';
import withSubscription from 'src/components/WithAuthorization/withSubscription';
import withLocationLock from 'src/components/WithAuthorization/withLocationLock';
import { isSubscriptionStatusValid } from 'src/utils/helpers';

function SettingsPage() {
    const [settings, setSettings] = useState(null);
    const [refetch, setRefetch] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await Api.request({
                    url: '/retailer/settings'
                });

                setSettings(data);
            } catch (err) {
                console.error(err);
            }
        })();
    }, [refetch]);

    return (
        <>
            <Head>
                <title>Settings - Tote Dashboard</title>
            </Head>

            <Container>
                {settings ? <Settings setRefetch={setRefetch} settings={settings} /> : <Loader />}
            </Container>
        </>
    );
}

export default withAuth(withLocationLock()(withSubscription(isSubscriptionStatusValid)(SettingsPage)));
